module.exports = __webpack_public_path__ + "img/tg_01 (9).200d2d24.jpg";